import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { Component, Injector, ViewChild } from '@angular/core';

import type { ConnectedOverlayDirective } from '@core/user-interface-legacy';
import { RtTooltip } from '@core/user-interface-legacy';

import { WysiwygInlineButtonComponent } from '../../../wysiwyg-inline-button/wysiwyg-inline-button.component';
import { WysiwygEmbeddableComponent } from '../../adapter/wysiwyg-adapter.types';
import { Placeholder } from '../placeholder';
import { WysiwygPlaceholderDropdownComponent } from './wysiwyg-placeholder-dropdown/wysiwyg-placeholder-dropdown.component';
import type { WysiwygPlaceholderAction } from './wysiwyg-placeholder.types';

export interface WysiwygPlaceholderState {
  placeholders: Placeholder[];
  active: Placeholder;
  activeIdWithoutBrackets: string;
  tooltipMessage?: string | null;
}

@Component({
  selector: 'rt-wysiwyg-placeholder',
  templateUrl: './wysiwyg-placeholder.component.html',
  styleUrls: ['./wysiwyg-placeholder.component.less'],
  imports: [
    WysiwygInlineButtonComponent,
    CdkOverlayOrigin,
    RtTooltip,
    CdkConnectedOverlay,
    WysiwygPlaceholderDropdownComponent,
  ],
})
export class WysiwygPlaceholderComponent extends WysiwygEmbeddableComponent<
  WysiwygPlaceholderState,
  WysiwygPlaceholderAction
> {
  @ViewChild('placeholdersDropdown', { static: true })
  public placeholdersDropdown: ConnectedOverlayDirective;

  public state: WysiwygPlaceholderState;
  public dropdownOpen: boolean = false;

  constructor(protected injector: Injector) {
    super(injector);

    this.state = {
      active: new Placeholder('empty', { description: null, value: null, status: null }),
      activeIdWithoutBrackets: 'empty',
      placeholders: [],
    };
  }

  public ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  public toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
    this.cdRef.detectChanges();
  }

  protected onStateChange(
    stateUpdate: Partial<WysiwygPlaceholderState>,
    prevState: WysiwygPlaceholderState,
  ): void {
    const nextState = {
      ...prevState,
      ...stateUpdate,
    };

    this.state = {
      ...nextState,
      activeIdWithoutBrackets: nextState.active.interpolated
        ? nextState.active.value
        : nextState.active.id.slice(1, -1),
      placeholders: nextState.placeholders,
      tooltipMessage: nextState.active.interpolated
        ? nextState.active.id
        : nextState.active.data.status?.invalid
          ? nextState.active.data.status.message
          : nextState.active.data.description,
    };

    this.cdRef.detectChanges();
  }
}
